// page chunk
export const LANDING_PAGE_CHUNK_NAME = 'landing';
export const DASHBOARD_PAGE_CHUNK_NAME = 'dashboard';
export const BOOKMARK_PAGE_CHUNK_NAME = 'bookmark';
export const FAVORITE_PAGE_CHUNK_NAME = 'favorite';
export const QA_QUESTION_LIST_PAGE_CHUNK_NAME = 'qa-question-list';
export const QA_QUESTION_PAGE_CHUNK_NAME = 'qa-question';
export const QA_QUESTION_ASK_PAGE_CHUNK_NAME = 'qa-question-ask';
export const QA_QUESTION_ASKED_PAGE_CHUNK_NAME = 'qa-question-asked';
export const NOTES_PAGE_CHUNK_NAME = 'notes';
export const NOTES_DETAILS_PAGE_CHUNK_NAME = 'notes-detail';
export const NOTES_PRINT_PAGE_CHUNK_NAME = 'note-print';
export const MAIN_MODE_COURSE_PAGE_CHUNK_NAME = 'course';
export const MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME = 'course-challenge-mode';
export const MAIN_MODE_COURSE_VIDEO_MODE_PAGE_CHUNK_NAME = 'course-video-mode';
export const MAIN_MODE_COURSE_LIVE_MODE_PAGE_CHUNK_NAME = 'course-live-mode';
export const MAIN_MODE_COURSE_EXERCISE_PAGE_CHUNK_NAME = 'course-exercise';
export const MAIN_MODE_COURSE_EVENTS_PAGE_CHUNK_NAME = 'course-events';
export const MAIN_MODE_COURSE_FLASHCARD_LANDING_PAGE_CHUNK_NAME = 'course-flashcard-landing';
export const MAIN_MODE_COURSE_FAVORITE_PAGE_CHUNK_NAME = 'course-favorite';
export const MAIN_MODE_COURSE_RANKING_PAGE_CHUNK_NAME = 'course-ranking';
export const MAIN_MODE_COURSE_MATERIAL_PAGE_CHUNK_NAME = 'course-material';
export const MAIN_MODE_COURSE_CLASSROOM_PAGE_CHUNK_NAME = 'course-classroom';
export const MINI_MODE_COURSE_PAGE_CHUNK_NAME = 'mini-course';
export const FREE_MODE_COURSE_PAGE_CHUNK_NAME = 'free-course';
export const TRAIL_MODE_COURSE_PAGE_CHUNK_NAME = 'trail-course';
export const MAIN_MODE_BOOK_PAGE_CHUNK_NAME = 'book';
export const MINI_MODE_BOOK_PAGE_CHUNK_NAME = 'mini-book';
export const FREE_MODE_BOOK_PAGE_CHUNK_NAME = 'free-book';
export const READER_MODE_BOOK_PAGE_CHUNK_NAME = 'reader-book';
export const TRAIL_MODE_BOOK_PAGE_CHUNK_NAME = 'trail-book';
export const EXERCISE_PAGE_CHUNK_NAME = 'exercise';
export const EVENTS_PAGE_CHUNK_NAME = 'events';
export const IDENTITY_PAGE_CHUNK_NAME = 'identity';
export const REFERRAL_PAGE_CHUNK_NAME = 'referral';
export const MESSAGE_PAGE_CHUNK_NAME = 'message';
export const MESSAGE_BK_PAGE_CHUNK_NAME = 'message-bk';
export const SETTING_PAGE_CHUNK_NAME = 'setting';
export const LOGIN_PAGE_CHUNK_NAME = 'login';
export const LOGIN_KECUHUI_PAGE_CHUNK_NAME = 'login-kecuhui';
export const LOGIN_PHONE_PAGE_CHUNK_NAME = 'login-phone';
export const LOGOUT_PAGE_CHUNK_NAME = 'logout';
export const PASSWORD_FORGET_PAGE_CHUNK_NAME = 'password-forget';
export const PASSWORD_CONFIRM_PAGE_CHUNK_NAME = 'password-confirm';
export const PASSWORD_RESET_PAGE_CHUNK_NAME = 'password-reset';
export const PASSWORD_SUCCESS_PAGE_CHUNK_NAME = 'password-success';
export const MUST_READ_PAGE_CHUNK_NAME = 'must-read';
export const LAYOUT_TEMPLATE_PAGE_CHUNK_NAME = 'layout-template';
export const LAYOUT_TEMPLATE1_PAGE_CHUNK_NAME = 'layout-template1';
export const LAYOUT_TEMPLATE2_PAGE_CHUNK_NAME = 'layout-template2';
export const PURE_MODE_BOOK_PAGE_CHUNK_NAME = 'pure-book';
export const PURE_MODE_COURSE_PAGE_CHUNK_NAME = 'pure-course';
export const MALL_PAGE_CHUNK_NAME = 'mall';
export const MALL_ITEM_PAGE_CHUNK_NAME = 'mall-item';
export const MALL_CATEGORY_PAGE_CHUNK_NAME = 'mall-category';
export const MALL_GOOD_PAGE_CHUNK_NAME = 'mall-good';
export const MALL_ESG_REGISTRATION_PAGE_CHUNK_NAME = 'esg-registration';
export const ESG_ORDER_COMPLETED_PAGE_CHUNK_NAME = 'esg-order-completed';
export const MALL_CATEGORY_COUPON_PAGE_CHUNK_NAME = 'mall-category-coupon';
export const MALL_GOOD_COUPON_PAGE_CHUNK_NAME = 'mall-good-coupon';
export const MALL_ORDER_PAGE_CHUNK_NAME = 'mall-order';
export const MALL_TRADE_PAGE_CHUNK_NAME = 'mall-trade';
export const MALL_WRITE_OFF_PAGE_CHUNK_NAME = 'mall-write-off';
export const MALL_PAYPAL_PAGE_CHUNK_NAME = 'mall-paypal';
export const ACHIEVEMENTS_PAGE_CHUNK_NAME = 'achievements';
export const READER_PAGE_CHUNK_NAME = 'reader';
export const POINTS_PAGE_CHUNK_NAME = 'points';
export const PRIVACY_PAGE_CHUNK_NAME = 'privacys';
export const ACCOUNT_CANCELLATION_PAGE_CHUNK_NAME = 'account-cancellation';
export const RANKING_PAGE_CHUNK_NAME = 'ranking';
export const ACTIVITY_TRANSCRIPT_PAGE_CHUNK_NAME = 'activity-transcript';
export const EVENT_REDIRECT_PAGE_CHUNK_NAME = 'event-redirect';
export const ALL_COURSES_PAGE_CHUNK_NAME = 'all-courses';
export const COUPON_PAGE_CHUNK_NAME = 'coupon';
export const FLASH_CARD_DETAIL_PAGE_CHUNK_NAME = 'flash-card-detail';
export const FLASH_CARD_FAVORITE_PAGE_CHUNK_NAME = 'flash-card-favorite';
export const FLASH_CARD_LANDING_PAGE_CHUNK_NAME = 'flash-card-landing';
export const TEACHERS_PAGE_CHUNK_NAME = 'teachers';
export const APP_PAGE_CHUNK_NAME = 'app';
export const ABOUT_PAGE_CHUNK_NAME = 'about';
export const LEGAL_PAGE_CHUNK_NAME = 'legal';
export const TRAINING_CAMP_PAGE_CHUNK_NAME = 'training-camp';
export const TRAINING_CAMP_PERSONAL_PAGE_CHUNK_NAME = 'training-camp-personal';
export const TRAINING_CAMPS_PAGE_CHUNK_NAME = 'training-camps';

export const ORDER_DETAIL_PAGE_CHUNK_NAME = 'order-detail';
export const MY_ORDER_PAGE_CHUNK_NAME = 'my-order';

export const IM_TEAM_ANNOUNCEMENT_PAGE_CHUNK_NAME = 'im';
export const ALUMNI_PAGE_CHUNK_NAME = 'alumni';

export const AI_PAGE_CHUNK_NAME = 'ai';
// export const INVOICE_PAGE_CHUNK_NAME = 'invoice';
export const CAREER_PAGE_CHUNK_NAME = 'career';
//export const AGREEMENT_PAGE_CHUNK_NAME = 'agreement';

// page access map
export const PAGE_ACCESS_MAP = {
  [ACCOUNT_CANCELLATION_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [PRIVACY_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: false, needsAuth: false } },
  [POINTS_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  [MALL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [MALL_ITEM_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [MALL_CATEGORY_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [MALL_GOOD_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [MALL_CATEGORY_COUPON_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [MALL_GOOD_COUPON_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [MALL_ORDER_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
    isShowMsg: true,
    isFetchUserInfo: true,
  },
  [MALL_TRADE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
    isShowMsg: true,
    isFetchUserInfo: true,
  },
  [MALL_WRITE_OFF_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
    isFetchUserInfo: true,
  },
  [MALL_PAYPAL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
    isShowMsg: true,
  },
  [ACHIEVEMENTS_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [READER_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  [PURE_MODE_BOOK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [`${PURE_MODE_BOOK_PAGE_CHUNK_NAME}-reading`]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  //[PURE_MODE_COURSE_PAGE_CHUNK_NAME]: {
  //  access: { needsLogin: true, needsPhone: true, needsAuth: true },
  //},
  [LANDING_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [DASHBOARD_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [QA_QUESTION_LIST_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [QA_QUESTION_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [QA_QUESTION_ASK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [QA_QUESTION_ASKED_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [NOTES_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: true, needsAuth: false } },
  [NOTES_DETAILS_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [NOTES_PRINT_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  //[MAIN_MODE_COURSE_PAGE_CHUNK_NAME]: {
  //  access: { needsLogin: true, needsPhone: true, needsAuth: true },
  //},
  [MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [MAIN_MODE_COURSE_VIDEO_MODE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [MAIN_MODE_COURSE_LIVE_MODE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [MAIN_MODE_COURSE_EXERCISE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MAIN_MODE_COURSE_EVENTS_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MAIN_MODE_COURSE_FLASHCARD_LANDING_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MAIN_MODE_COURSE_FAVORITE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [MAIN_MODE_COURSE_RANKING_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MAIN_MODE_COURSE_MATERIAL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MAIN_MODE_COURSE_CLASSROOM_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MINI_MODE_COURSE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [FREE_MODE_COURSE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [TRAIL_MODE_COURSE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [MAIN_MODE_BOOK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [`${MAIN_MODE_BOOK_PAGE_CHUNK_NAME}-reading`]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [MINI_MODE_BOOK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [FREE_MODE_BOOK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [`${FREE_MODE_BOOK_PAGE_CHUNK_NAME}-reading`]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [READER_MODE_BOOK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [TRAIL_MODE_BOOK_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [EXERCISE_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  [EVENTS_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: true, needsAuth: false } },
  [IDENTITY_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
    isFetchUserInfo: true,
  },
  [REFERRAL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
    isShowMsg: true,
    isNotPopMsg: true,
  },
  [MESSAGE_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  //[MESSAGE_BK_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  [SETTING_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
    isFetchUserInfo: true,
  },
  [LOGIN_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: false, needsAuth: false } },
  [LOGIN_KECUHUI_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [LOGIN_PHONE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: false, needsAuth: false },
  },
  [LOGOUT_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: false, needsAuth: false } },
  [PASSWORD_FORGET_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [PASSWORD_CONFIRM_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [PASSWORD_RESET_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [PASSWORD_SUCCESS_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [BOOKMARK_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: true, needsAuth: false } },
  //[FAVORITE_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: true, needsAuth: false } },
  [LAYOUT_TEMPLATE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [LAYOUT_TEMPLATE1_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [LAYOUT_TEMPLATE2_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
  },
  [MALL_ESG_REGISTRATION_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: false, needsAuth: false },
  },
  [ESG_ORDER_COMPLETED_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: false, needsAuth: false },
  },
  //[RANKING_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  [ACTIVITY_TRANSCRIPT_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [EVENT_REDIRECT_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [ALL_COURSES_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [COUPON_PAGE_CHUNK_NAME]: { access: { needsLogin: true, needsPhone: true, needsAuth: false } },
  [FLASH_CARD_DETAIL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [FLASH_CARD_FAVORITE_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [FLASH_CARD_LANDING_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
    isShowMsg: true,
  },
  [TEACHERS_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: false, needsAuth: false },
    isShowMsg: true,
  },
  [APP_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: false, needsAuth: false } },
  [ABOUT_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: false, needsAuth: false } },
  [LEGAL_PAGE_CHUNK_NAME]: { access: { needsLogin: false, needsPhone: false, needsAuth: false } },
  [TRAINING_CAMP_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [TRAINING_CAMP_PERSONAL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },

  [TRAINING_CAMPS_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: true },
  },
  [ORDER_DETAIL_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [MY_ORDER_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  [IM_TEAM_ANNOUNCEMENT_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [ALUMNI_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [AI_PAGE_CHUNK_NAME]: {
    access: { needsLogin: false, needsPhone: true, needsAuth: false },
  },
  [CAREER_PAGE_CHUNK_NAME]: {
    access: { needsLogin: true, needsPhone: true, needsAuth: false },
  },
  // [INVOICE_PAGE_CHUNK_NAME]: {
  //   access: { needsLogin: false, needsPhone: true, needsAuth: false },
  // },
  //[AGREEMENT_PAGE_CHUNK_NAME]: {
  //  access: { needsLogin: false, needsPhone: true, needsAuth: false },
  //},
};
